export const getInfoPrivacyEndpoint = 'profilo-ms/ms/profile/getInfoPrivacy';
export const setInfoPrivacyEndpoint =
  'profilo-ms/ms/profile/auth/setInfoPrivacy';
